import React from 'react';

import {GenericPaginatedListRTK} from 'app/components/general/lists/GenericPaginatedListRTK';
import {useFolders} from 'app/folders/api';
import {FolderItem} from 'app/folders/components/FolderItem';
import {KBTreeDeleteItemContextProvider} from 'app/kbs/components/KBEditPage/KBTree/KBTreeDeleteItemModal';
import {useRemoveTeamItem} from 'app/teams/api';
import {gt} from 'app/utils/i18n';

import {AddNewTeamFolderButton} from './AddNewTeamFolderButton';

import {TeamPageFilterBarStructure} from '../components/TeamPageFilterBarStructure';

import type {ListItemProps} from '../components/TeamListItem';
import type {MenuItemsType} from 'app/general/widgets/ThreeDotsDropdownMenu';
import type {
  FolderSerializedType,
  FolderTeamMembershipSerializedType,
  TeamSerializedType,
} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  onFetch: () => unknown;
};

export const TeamFoldersSubPage = ({team}: Props) => {
  return (
    <div>
      {team.can_edit ? (
        <TeamPageFilterBarStructure>
          <div className="col-auto ml-auto">
            <AddNewTeamFolderButton team={team} />
          </div>
        </TeamPageFilterBarStructure>
      ) : null}
      <GenericPaginatedListRTK
        ItemComponent={FolderListItem}
        useQuery={useFolders}
        noItemsMessage={(perms, NoResultsMessage) => (
          <NoResultsMessage
            head={gt('No folders for this team')}
          ></NoResultsMessage>
        )}
        pageParamName="folders_page"
        fetchPageName="folders_page"
        paramsBuilder={() => ({
          team_id: team.id,
          ordering: 'name',
          parent: '',
        })}
        customProps={() => ({
          team,
        })}
        WrapperComponent={KBTreeDeleteItemContextProvider}
      />
    </div>
  );
};

type FolderListItemProps = ListItemProps<FolderSerializedType> & {
  team: TeamSerializedType;
};

const FolderListItem = (props: FolderListItemProps) => {
  const [removeTeamItem] = useRemoveTeamItem();

  const actionsGetter = (object: FolderSerializedType): MenuItemsType => {
    let membership: FolderTeamMembershipSerializedType | undefined;

    if (props.team != null) {
      const teamURL: string = props.team.url;
      membership = object.team_memberships.find(
        (m) => m.team.indexOf(teamURL) != -1
      );
    }

    return [
      {
        text: gt('Remove from team'),
        icon: 'fa fa-times',
        key: 'remove-from-team',
        condition: () => membership != null && props.team.can_edit,
        callback: () =>
          removeTeamItem({teamURL: props.team.url, item: props.object}),
      },
    ];
  };

  return (
    <FolderItem
      key={props.object.url}
      folder={props.object}
      team={props.team || undefined}
      afterAction={props.refetchList}
      actionsGetter={actionsGetter}
      isParentDirty={false}
    />
  );
};
